import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeamBasicInfoFragment = { __typename?: 'OrganisationTeam', id: string, uuid: string, name: string, postsScreeningEnabled: boolean };

export type CreateTeamMutationVariables = Types.Exact<{
  data: Types.CreateOrganisationTeam;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'OrganisationTeam', id: string, uuid: string, name: string, postsScreeningEnabled: boolean, members: Array<{ __typename?: 'OrganisationTeamMember', id: string }>, organisation: { __typename?: 'Organisation', id: string } } };

export const TeamBasicInfoFragmentDoc = gql`
    fragment TeamBasicInfo on OrganisationTeam {
  id
  uuid
  name
  postsScreeningEnabled
}
    `;
export const CreateTeamDocument = gql`
    mutation CreateTeam($data: CreateOrganisationTeam!) {
  createTeam(data: $data) {
    ...TeamBasicInfo
    members {
      id
    }
    organisation {
      id
    }
  }
}
    ${TeamBasicInfoFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;